import type { UserRole } from "./models/userRole";

export interface PageInfo {
  readonly url: string;
  readonly name: string;
  readonly icon: string;
  readonly requiredRole?: UserRole;
}

export const createPageInfo = (
  name: string,
  url: string,
  icon: string,
  requiredRole?: UserRole,
): PageInfo => ({
  name: name,
  url: url,
  icon: icon,
  requiredRole: requiredRole,
});

export const mainSitePages: PageInfo[] = [
  createPageInfo("Home", "/", "house"),
  createPageInfo("Chi siamo", "/details", "circle-info"),
  createPageInfo("Eventi", "/events", "calendar"),
  createPageInfo("Galleria", "/gallery", "image"),
  createPageInfo("Classifica", "/scores", "ranking-star"),
  createPageInfo("Consiglio direttivo", "/group", "users"),
  createPageInfo("Area riservata", "/admin/", "user"),
];

export const getRoleAvailablePages = (
  pages: PageInfo[],
  role: Parameters<typeof getRolePriority>["0"] | undefined,
) =>
  !!role
    ? pages.filter(
        (x) =>
          !!!x.requiredRole ||
          getRolePriority(x.requiredRole) <= getRolePriority(role),
      )
    : [];
